popAndFlyManager = {};
popAndFlyManager.active = [];

popAndFlyManager.create = function () {
  return popAndFlyManager;
};

popAndFlyManager.initialise = function () {
  popAndFlyManager.animTimes = { RTFSB: 1600, FSRTMB: 1200 };

  Reflex.addToUpdate(popAndFlyManager.update);
};

popAndFlyManager.updateItemLayout = function (item) {
  if (item.type === "RTFSB") {
    var reel = gameData.reels[item.data.reel];
    item.source.x =
      reel.position.getX() + reel.Props.viewportWidth * reel.scale.x * 0.5;
    item.source.y =
      reel.position.getY() +
      reel.Props.appertureSpacing * reel.scale.y * (item.data.row + 0.5);
    item.dest.x = 0; //freespinsTrail.getTorchX();
    item.dest.y = 0; //freespinsTrail.getTorchY();
  }

  var prog = item.time / item.maxTime;
  item.delta.x = item.dest.x - item.source.x;
  item.delta.y = item.dest.y - item.source.y;
  item.time = item.maxTime * prog;
  item.maxTime =
    (Math.sqrt(item.delta.x * item.delta.x + item.delta.y * item.delta.y) /
      popAndFlyManager.animTimes[item.type]) *
    1000;
};

popAndFlyManager.updateLayout = function () {
  for (var i = 0; i < popAndFlyManager.active.length; i++) {
    popAndFlyManager.updateItemLayout(popAndFlyManager.active[i]);
  }
};

popAndFlyManager.add = function (type, callback, data) {
  if (checkForUndefined(popAndFlyManager.animTimes[type])) {
    console.error(
      "popAndFlyManager: Animation type '" + type + "' is not a valid animation"
    );
    return;
  }

  var newAnim = {};
  newAnim.type = type;
  newAnim.callback = callback;
  newAnim.time = 0;
  newAnim.maxTime = popAndFlyManager.animTimes[type];
  newAnim.source = { x: 0, y: 0 };
  newAnim.dest = { x: 0, y: 0 };
  newAnim.delta = { x: 0, y: 0 };
  newAnim.data = data;

  popAndFlyManager.active.push(newAnim);
  popAndFlyManager.updateItemLayout(newAnim);
};

popAndFlyManager.addReelToFrespinsBar = function (reel, row, completeCallback) {
  popAndFlyManager.add("RTFSB", completeCallback, { reel: reel, row: row });
};

popAndFlyManager.disable = function () {
  popAndFlyManager.enable(false);
};

popAndFlyManager.update = function (delta) {
  for (var i = popAndFlyManager.active.length - 1; i >= 0; i--) {
    var anim = popAndFlyManager.active[i];
    anim.time += delta;
    popAndFlyManager.active.splice(i, 1);
    anim.callback();
  }
};

Reflex.registerEventHandler("orientationChange", popAndFlyManager.updateLayout);
resourceManager.registerPlugIn();
resourceManager.registerController("popAndFlyManager", popAndFlyManager.create);
